module.exports = __webpack_public_path__ + "static/media/Patterson Farms Logo white.6c08ace9.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/logos/Patterson Farms Logo white.png
// module id = 256
// module chunks = 0